export const schedulingQueryKeys = {
  all: ['scheduling'] as const,
  getById: (questionnaireId: string) =>
    [...schedulingQueryKeys.all, 'getById', questionnaireId] as const,
};
